import { Box, Divider, Grid2, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { isToday } from "date-fns";
import { useMemo } from "react";

import {
  getLiveData,
  getSelectedPowerPlant,
  getShowLiveData,
  useAppSelector,
} from "store";
import { stalePulseSx } from "styles/animations";
import { formatEnergy, formatPower } from "utils/energy";

export const LiveData = ({ show: providedShow }: { show?: boolean }) => {
  const liveData = useAppSelector(getLiveData);
  const selectedPowerPlant = useAppSelector(getSelectedPowerPlant);
  const showLiveData = useAppSelector(getShowLiveData);
  const show = providedShow || showLiveData;

  const offline = selectedPowerPlant?.offline;
  const dataFromToday = liveData?.date ? isToday(liveData.date) : false;

  const energyProduced = formatEnergy(
    liveData ? liveData.energyProduced.day : 0,
  );
  const power = useMemo(
    () =>
      formatPower(
        liveData
          ? Object.values(liveData.power).reduce((sum, phase) => sum + phase, 0)
          : 0,
      ),
    [liveData],
  );
  if (!liveData || !show) return null;

  const showEnergy = !offline || dataFromToday;

  return (
    <Grid2
      container
      size={12}
      spacing={2}
      justifyContent={"center"}
      alignItems={"center"}
    >
      <Grid2
        container
        justifyContent="flex-end"
        alignItems={"flex-end"}
        spacing={1}
        size={5}
      >
        <Typography fontSize={15} fontWeight={700}>
          {offline ? "—" : power.value}
        </Typography>
        {!offline && (
          <Typography color={grey[700]} fontSize={15} fontWeight={700}>
            {power.unit}
          </Typography>
        )}
      </Grid2>
      <Divider orientation="vertical" flexItem />
      <Grid2 container alignItems={"flex-end"} spacing={1} size={5}>
        <Box
          sx={
            offline && dataFromToday
              ? {
                  ...stalePulseSx(),
                  display: "flex",
                  alignItems: "flex-end",
                  gap: 1,
                }
              : { display: "flex", alignItems: "flex-end", gap: 1 }
          }
        >
          <Typography fontSize={15} fontWeight={700}>
            {showEnergy ? energyProduced.value : "—"}
          </Typography>
          {showEnergy && (
            <Typography color={grey[700]} fontSize={15} fontWeight={700}>
              {energyProduced.unit}
            </Typography>
          )}
        </Box>
      </Grid2>
    </Grid2>
  );
};
